export default __webpack_public_path__ + "static/media/Ticket remove 1.c3448354.svg";